import { render, staticRenderFns } from "./EntradaPage.vue?vue&type=template&id=37a2ecfd"
import script from "./EntradaPage.vue?vue&type=script&lang=js"
export * from "./EntradaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports